document.addEventListener("DOMContentLoaded", function() {
	
	document.querySelectorAll('[data-modal-name="salsac-modal"]').forEach(button => {
		button.addEventListener('click', () => {
			const currentStage = button.getAttribute('current-stage');
			const nextStage = button.getAttribute('next-stage');

			console.log('currentStage' + currentStage);
			console.log('nextStage' + nextStage);

			const modal = button.closest(`[data-modal-name="salsac-modal"]`) || document;

			const currentStageEl = document.querySelector(`[data-stage="${currentStage}"]`);
			if (currentStageEl) {
				currentStageEl.classList.add('hidden');
			}

			const nextStageEl = document.querySelector(`[data-stage="${nextStage}"]`);
			if (nextStageEl) {
				nextStageEl.classList.remove('hidden');
			}
		});
	});



	document.querySelectorAll('.open-salsac-modal').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('salsac-modal');
			modal.classList.toggle('hidden');
		});
	});

	const salsacForm = document.getElementById('salsac-form');
	if (salsacForm) {
		const employeeFaqs = document.querySelectorAll('.employee-faq');
		const employerFaqs = document.querySelectorAll('.employer-faq');
		const bossDetails = document.getElementById('your_boss_details');
		const companyDetails = document.getElementById('your_company');
		const yourDetails = document.getElementById('your_details');
		const yourBossDetailsInfo = document.getElementById('your_boss_details_info');
		const yourDetailsInfo = document.getElementById('your_details_info');
		const employeeBtns = document.querySelectorAll('.im_an_employee');
		const employerBtns = document.querySelectorAll('.im_an_employer');
		const bookInACallBtns = document.querySelectorAll('.book_in_a_call');

		// Helper functions
		const hideElements = elements => elements.forEach(el => el.classList.add('hidden'));
		const showElements = elements => elements.forEach(el => el.classList.remove('hidden'));

		// Hide everything by default
		// hideElements(employeeFaqs);
		// hideElements(employerFaqs);
		if (bossDetails) bossDetails.classList.add('hidden');
		if (companyDetails) companyDetails.classList.add('hidden');
		if (yourBossDetailsInfo) yourBossDetailsInfo.classList.add('hidden');
		if (yourDetailsInfo) yourDetailsInfo.classList.add('hidden');

		// "Book in a call" click for ALL buttons
		bookInACallBtns.forEach(btn => {
			btn.addEventListener('click', () => {
				console.log(58);
				document.querySelector(`[data-stage="1"]`).classList.remove('hidden');
				document.querySelector(`[data-stage="2"]`).classList.add('hidden');
				document.querySelector(`[data-stage="3"]`).classList.add('hidden');
			});
		});

		// "I'm an employee" click for ALL buttons
		employeeBtns.forEach(btn => {
			btn.addEventListener('click', () => {
				console.log(1);
				// showElements(employeeFaqs);
				if (bossDetails) bossDetails.classList.remove('hidden');
				if (yourBossDetailsInfo) yourBossDetailsInfo.classList.remove('hidden');

				// hideElements(employerFaqs);
				if (companyDetails) companyDetails.classList.add('hidden');
				if (yourDetailsInfo) yourDetailsInfo.classList.add('hidden');

				document.querySelector(`[data-stage="1"]`).classList.add('hidden');
				document.querySelector(`[data-stage="2"]`).classList.remove('hidden');
				document.querySelector(`[data-stage="3"]`).classList.add('hidden');
			});
		});

		// "I'm an employer" click for ALL buttons
		employerBtns.forEach(btn => {
			btn.addEventListener('click', () => {
				console.log(2);
				// showElements(employerFaqs);
				if (companyDetails) companyDetails.classList.remove('hidden');
				if (yourDetailsInfo) yourDetailsInfo.classList.remove('hidden');

				// hideElements(employeeFaqs);
				if (bossDetails) bossDetails.classList.add('hidden');
				if (yourBossDetailsInfo) yourBossDetailsInfo.classList.add('hidden');

				document.querySelector(`[data-stage="1"]`).classList.add('hidden');
				document.querySelector(`[data-stage="2"]`).classList.remove('hidden');
				document.querySelector(`[data-stage="3"]`).classList.add('hidden');
			});
		});
	}


});

document.addEventListener('DOMContentLoaded', function () {
	const form = document.getElementById('salsac-form');
	if (!form) return;

	// Helpers
	const $ = (sel) => form.querySelector(sel);
	const val = (name) => ($(`[name="${name}"]`)?.value || '').trim();
	const isChecked = (name) => ($(`[name="${name}"]`)?.checked === true);

	// Ensure there is a hidden input for g-recaptcha-response
	if (!form.querySelector('input[name="g-recaptcha-response"]')) {
		const inp = document.createElement('input');
		inp.type = 'hidden';
		inp.name = 'g-recaptcha-response';
		form.appendChild(inp);
	}

	form.addEventListener('submit', function (e) {
		e.preventDefault();

		// Require consent
		if (!isChecked('consent')) {
			alert('Please confirm consent before submitting.');
			return;
		}

		const submitBtn = form.querySelector('[type="submit"]');
		const originalBtnText = submitBtn ? submitBtn.textContent : '';
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Sending...';
		}

		const siteKey = form.dataset.recaptcha;
		if (!siteKey || typeof grecaptcha === 'undefined') {
			if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalBtnText; }
			alert('reCAPTCHA is not configured. Please try again later.');
			return;
		}

		grecaptcha.ready(function () {
			grecaptcha.execute(siteKey, { action: 'contact' }).then(function (token) {
				form.querySelector('input[name="g-recaptcha-response"]').value = token;

				const forename	= val('forename');
				const surname	 = val('surname');
				const email		 = val('email');
				const telephone = val('telephone');

				const bossForename = val('boss_forename');
				const bossSurname	= val('boss_surname');
				const bossEmail		= val('boss_email');

				const companyName	= val('your_full_limited_company_name');
				const jobTitle		 = val('your_job_title');
				const companySize	= val('company_size_in_the_uk');
				const howHear			= val('howDidYouHear');

				const comments =
					[
						`Applicant Forename: ${forename}`,
						`Applicant Surname: ${surname}`,
						`Applicant Email: ${email}`,
						`Applicant Telephone: ${telephone}`,
						`Boss Forename: ${bossForename}`,
						`Boss Surname: ${bossSurname}`,
						`Boss Email: ${bossEmail}`,
						`Company Name: ${companyName}`,
						`Job Title: ${jobTitle}`,
						`Company Size (UK): ${companySize}`,
						`How did you hear about us?: ${howHear}`
					].filter(Boolean).join('\n');

				const csrf = val('_token');

				const payload = {
					type: val('form-type') || 'SALSAC',
					name: `${forename} ${surname}`.trim(),
					forename,
					surname,
					company: companyName,
					email,
					telephone,
					comments,
					_token: csrf,
					'g-recaptcha-response': token,
					'alternative-mailto': val('alternative-mailto') || null,
					crm_alt: form.querySelector('[name="crm_alt"]') ? 'true' : 'false'
				};

				const url = form.getAttribute('action') || '/contact';

				fetch(url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(payload)
				})
				.then(function (response) {
					if (!response.ok) throw new Error('Network response was not OK: ' + response.status);
					return response.json();
				})
				.then(function (data) {
					if (data.status !== 'ok') {
						const errors = data.errors ? Object.values(data.errors).map(arr => arr[0]).join('\n') : 'Unknown error';
						throw new Error(errors);
					}
					
					if (document.querySelector(`[data-stage="2"]`)) {
						document.querySelector(`[data-stage="2"]`).classList.add('hidden');
					}

					if (document.querySelector(`[data-stage="3"]`)) {
						document.querySelector(`[data-stage="3"]`).classList.remove('hidden');
					}
					
					form.reset();

					// GTM
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({ event: 'SALSAC Enquiry Received' });
				})
				.catch(function (err) {
					console.error('Submit Error:', err);
					alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
				})
				.finally(function () {
					if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalBtnText; }
				});
			});
		});
	});
});
document.addEventListener("DOMContentLoaded", function () {
	const faqHeaders = document.querySelectorAll(".salsac-header");

	faqHeaders.forEach(header => {
		header.addEventListener("click", function () {
			const parent = header.closest(".salsac-box");
			parent.classList.toggle("open");
		});
	});
});